import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

const useStyles = makeStyles((theme) => ({
    titulo: {
        color: "#DF5900",
        float: "left",
        paddingLeft: "11.5px",
        fontSize: "22px",
      },
}));

const IconosEstado = () => {
  const classes = useStyles();

  return (
    <>  
      <Grid container justifyContent="flex-end" spacing={1}>
        <Grid container alignContent="flex-start" alignItems="center">
          <Typography inline className={classes.titulo}>
            Personal Sub-contratado
          </Typography>
        </Grid>
        <Grid item>
          <Grid container alignContent="space-between" alignItems="center">
            <Grid item>
              <IconButton>
                <ErrorOutlineOutlinedIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography inline>Pendiente de registro</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignContent="space-between" alignItems="center">
            <Grid item>
              <IconButton>
                <PendingOutlinedIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography inline>Pendiente de aprobación</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignContent="space-between" alignItems="center">
            <Grid item>
              <IconButton>
                <CheckCircleOutlineOutlinedIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography inline>Aprobado</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignContent="space-between" alignItems="center">
            <Grid item>
              <IconButton>
                <HighlightOffOutlinedIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography inline>Rechazado</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      
    </>
  );
};

export default IconosEstado;
